<template>
  <GridContainer class="outdoor-stage">
    <AnimatedGallery
      :animation="stageData.animation"
      :animation-duration="{
        enter: '0.5s',
        leave: '0.3s',
      }"
      :control-bar-type="'dots'"
      :items="offers"
      auto-play
    >
      <template #stageItem="{ selectedItem }">
        <GridRow align-v="center">
          <GridColumn
            :md="5"
            :xs="12"
            :no-padding="true"
          >
            <div class="outdoor-stage__text-container">
              <Heading
                tag="h3"
                font-weight="ultra"
                size="sm"
                :text="selectedItem?.stageContent?.heading"
              />
              <Heading
                tag="h4"
                font-weight="ultra"
                size="md"
                spaces-bottom
              >
                {{ selectedItem?.stageContent?.subheading }}
              </Heading>
              <Paragraph :text="selectedItem?.stageContent?.copy" />
            </div>
          </GridColumn>
          <GridColumn
            class="outdoor-stage__gallery"
            :md="7"
            :no-padding="true"
            :xs="12"
          >
            <CdnImage
              class="outdoor-stage__gallery-background"
              src="/content/content-images/landingpages/anker/outdoor/213c1b19005c3615a2e95b572feda1d6/solargeneratoren-bg@2x.jpg"
              lazy
            />

            <OutdoorProduct
              v-if="selectedItem"
              :offer="selectedItem.offer"
              :local-image="selectedItem.localImage"
              :custom-heading="selectedItem.stageContent.heading"
              :image-aspect-ratio="selectedItem.aspectRatio"
            />
          </GridColumn>
        </GridRow>
      </template>
    </AnimatedGallery>
  </GridContainer>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import {
  Heading,
  Paragraph,
  GridContainer,
  GridRow,
  GridColumn,
  AnimatedGallery,
} from '@i22/td-longtail-vue-components';
import CdnImage from '~/components/cdn-image.vue';
import useAnimation from './animations/scroll-animation';
import OutdoorProduct from './outdoor-product.vue';

const { createScrollTrigger } = useAnimation();

const props = defineProps({
  offers: { type: Array, default: () => [] },
});
const stageData = {
  animation: 'right-fade',
  bgImageMobile:
    'url("/content/content-images/landingpages/anker/outdoor/213c1b19005c3615a2e95b572feda1d6/solargeneratoren-bg@2x.jpg")',
};

const autoPlay = ref(false);
onMounted(() => {
  createScrollTrigger({
    trigger: '.outdoor-stage',
    start: 'bottom bottom',
    end: 'bottom bottom',
    onEnter() {
      autoPlay.value = true;
    },
  });
});
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.outdoor-stage {
  &__gallery {
    &-background {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      overflow: hidden;

      :deep(img) {
        min-width: 100%;
        min-height: 100%;
        object-fit: cover;
        object-position: center;
        aspect-ratio: 80 / 53;
        width: 100%;

        @include mq($mq-md) {
          object-position: left;
        }
      }
    }
  }
  &__text-container {
    padding: 3 * $grid-base;
    @include mq($mq-md) {
      max-width: 600px;
      padding: $grid-base 3 * $grid-base;
    }
  }
  :deep(.paragraph) {
    @include mq($mq-sm) {
      @include font-size(21px, 24px);
    }
  }
  :deep(.animated-gallery__stage) {
    line-height: inherit;
    height: 1210px;
    @include mq(400px) {
      height: 1088px;
    }
    @include mq($mq-sm) {
      height: 1051px;
      margin-bottom: unset;
    }
    @include mq($mq-md) {
      height: 612px;
    }
  }
  :deep(.animated-gallery__stage > div) {
    height: 100%;

    & > div {
      height: 100%;
    }
  }
  :deep(.animated-gallery) {
    padding: 0;
  }
  :deep(.animated-gallery__controls) {
    @include mq($mq-md) {
      display: none;
    }
  }
  :deep(.animated-gallery__overview) {
    @include mq($mq-md) {
      margin-top: $grid-base;
    }
  }
}
</style>
